import { app } from '@/application'
import { find } from 'lodash'

export default (product, action) =>
  find(
    app.currentUser.permissions,
    permission => permission.key === product
  )[action] ?? false
